<template>
  <div class="events">
    <div class="inner-content mt-5">
      <Alert></Alert>

      <v-select
        v-if="cities.length > 0"
        :items="cities"
        label="Всички"
        v-model="city"
        solo
        clearable
      ></v-select>

      <v-fade-transition>
        <div class="events-list" v-if="events.length > 0">
          <v-row>
            <Card
              v-for="(event, i) in events"
              :key="`event-${i}`"
              :title="event.title.rendered"
              :date="[event.event_start, 'X']"
              :image="event.thumbnail"
              :link="{ name: 'event', params: {slug: decodeURIComponent(event.slug)} }"
              dark
            ></Card>
          </v-row>
        </div>
      </v-fade-transition>

      <h3 class="title" v-if="events.length === 0 && !loading" v-html="notFoundMessage"></h3>

      <Pagination v-model="page"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Alert from '@/components/Utils/Alert.vue'
import Pagination from '@/components/Utils/Pagination.vue'
import Card from '@/components/Card.vue'

export default {
  name: 'EventsList',
  components: { Pagination, Alert, Card },

  data () {
    return {
      page: 1,
      city: ''
    }
  },

  mounted () {
    this.fetchEvents()
    this.fetchCities()

    this.$store.commit('setTabs', [
      { title: 'Предстоящи', link: { name: 'events' } },
      { title: 'Отминали', link: { name: 'events-past' } },
    ])
  },

  methods: {
    fetchEvents () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getEvents', { scope: this.scope, page: this.page }).then(() => {
        this.$store.commit('setLoading', false)
      }).catch(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на събитията.' })
      })
    },

    fetchCities () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getCities').then(() => {
        this.$store.commit('setLoading', false)
      }).catch(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на градовете.' })
      })
    }
  },

  computed: {
    scope () {
      return this.$route.name === 'events' ? 'future' : 'past'
    },
    cities () {
      return this.$store.getters.cities.map(city => {
        return { text: city.name, value: city.id }
      })
    },
    selectedCity () {
      return this.cities.find(city => city.value === this.city)
    },
    notFoundMessage () {
      const inCity = this.selectedCity ?
        (this.selectedCity.text.toLowerCase().indexOf('в') === 0 ? ' във ' : ' в ') + this.selectedCity.text : ''
      return `Не бяха намерени ${this.scope === 'future' ? 'предстоящи' : 'отминали'} събития${inCity}.`
    },
    ...mapGetters(['events', 'loading'])
  },

  watch: {
    city: 'fetchEvents',
    page: 'fetchEvents',
    '$route.name': 'fetchEvents'
  }
}
</script>

<style lang="scss">
.events-list {
  .v-card {
    flex: 1;
  }
}
</style>
